import React, { HTMLAttributes } from 'react';
import {
  AlignContentProps,
  alignItems,
  AlignItemsProps,
  alignSelf,
  background,
  color,
  display,
  DisplayProps,
  flex,
  FlexBasisProps,
  flexDirection,
  FlexDirectionProps,
  FlexProps,
  flexWrap,
  FlexWrapProps,
  gridGap,
  GridGapProps,
  height,
  justifyContent,
  JustifyContentProps,
  justifySelf,
  maxWidth,
  minHeight,
  minWidth,
  space,
  SpaceProps,
  textAlign,
  top,
  TopProps,
  width,
} from 'styled-system';
import { ColoringProps, SelfPositioningProps, SizingProps } from '~frontend-common/lib/styled-components';
import { styled } from '~ui-kit/styled-components';

export interface BoxProps
  extends ColoringProps,
    FlexWrapProps,
    FlexBasisProps,
    FlexProps,
    FlexDirectionProps,
    GridGapProps,
    SizingProps,
    SpaceProps,
    FlexProps,
    TopProps,
    AlignItemsProps,
    AlignContentProps,
    JustifyContentProps,
    SelfPositioningProps,
    DisplayProps,
    HTMLAttributes<HTMLDivElement> {
  color?: string;
}

/**
 * @deprecated use ~ui-kit/component/box instead
 */
export const Box: React.SFC<BoxProps> = styled.div`
  display: flex;
  position: relative;

  ${width};
  ${height};
  ${minHeight};
  ${space};
  ${flexDirection};
  ${alignSelf};
  ${justifySelf};
  ${justifyContent};
  ${alignItems};
  ${flex};
  ${color};
  ${flexWrap};
  ${textAlign};
  ${top};
  ${minWidth};
  ${maxWidth};
  ${background};
  ${display};
  ${gridGap}
` as any;
